import { AppConfig } from "../layout/service/app.layout.service";

export class ConfigUtils {

    private static readonly APP_CONFIG_KEY = 'config';

    public static getDefaultAppConfig(): AppConfig {
        var appConfig: AppConfig = localStorage.getItem(this.APP_CONFIG_KEY) != null ?
            JSON.parse(localStorage.getItem(this.APP_CONFIG_KEY)!) :
            {
                ripple: true,
                inputStyle: 'outlined',
                menuMode: 'static',
                colorScheme: 'dark',
                theme: 'mdc-dark-indigo',
                scale: 14
            };

        localStorage.setItem(this.APP_CONFIG_KEY, JSON.stringify(appConfig));

        return appConfig;
    }

    public static setLightMode(lightMode: boolean) {
        var appConfig: AppConfig = JSON.parse(localStorage.getItem(this.APP_CONFIG_KEY)!);

        if (appConfig) {
            appConfig.theme = lightMode ? 'mdc-light-indigo' : 'mdc-dark-indigo';
            appConfig.colorScheme = lightMode ? 'light' : 'dark';

            localStorage.setItem(this.APP_CONFIG_KEY, JSON.stringify(appConfig));
        }
    }
}